export default __webpack_public_path__ + "static/media/sample-card.302676e9.png";